import { DateTime } from "luxon";

import { InsulinPumpSegmentDTO } from "@/models/DeviceModel";

export const getBasalInsulinPerDay = (segments: InsulinPumpSegmentDTO[]): number => {
  let total = 0;
  for (const segment of segments) {
    const duration = DateTime.fromISO(segment.end_time).diff(DateTime.fromISO(segment.start_time)).as("minutes");
    total += (segment.basal_rate * duration) / 60;
  }
  return total;
};
